<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import AuditIdBaseMixin from "@/components/mixins/AuditIdBaseMixin";
import CreateAuditItemListManipulators from "@/utils/AuditItemListManipulator";

import { Importance } from "@/datatypes/Importance";

import { api } from "@/store/modules/audits";
import { api as auditApi } from "@/store/modules/audit";
import { api as confApi } from "@/store/modules/configuration";
import { uploadFile } from "@/utils/uploader";

export default {
  mixins: [AuditIdBaseMixin],
  data: () => ({
    currentAuditItem: null
  }),
  computed: {
    ...mapGetters(auditApi.namespace, [auditApi.getters.getAuditProgress]),
    ...mapGetters(confApi.namespace, [
      confApi.getters.audit,
      confApi.getters.audititem,
      confApi.getters.measure,
      confApi.getters.getFindingsOrder,
      confApi.getters.getFindingTypes
    ]),
    auditProgress() {
      return this.getAuditProgress;
    },
    auditItemManipulators() {
      let categories = {};
      if (this.currentAudit) {
        const standard_id =
          this.standardId instanceof Array
            ? this.currentAudit.standard[0]
            : this.currentAudit.standard;
        if (standard_id in this.$store.state.configuration.categories) {
          categories = _.keyBy(
            this.$store.state.configuration.categories[standard_id],
            "id"
          );
        }
      }

      return CreateAuditItemListManipulators(
        categories,
        this.getFindingsOrder,
        this.getFindingTypes
      );
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.setAuditId,
      api.actions.setAuditItemId,
      api.actions.setDialogItem,
      api.actions.setDialogAction,
      api.actions.deleteAuditItem,

      api.actions.setDeviationId
    ]),
    ...mapActions(auditApi.namespace, [
      auditApi.actions.storeFinding,
      auditApi.actions.attachFileToFinding
    ]),

    createCurrentAuditItem(audit_id) {
      console.log(audit_id);

      this.setDialogItem({ question: { chapters: [], text: "" } });
      this.setDialogAction("create");
      this.setAuditId(audit_id);

      this.dialogAuditItem = true;
    },
    updateCurrentAuditItem(audit_id, audititem_id, audititem) {
      this.setAuditId(audit_id);
      this.setAuditItemId(audititem_id);

      this.setDialogItem({ ...audititem });
      this.setDialogAction("update");

      console.log("Update Audititem");
      this.dialogAuditItem = true;
    },
    deleteCurrentAuditItem(audit_id, audititem_id) {
      //this.setAuditId(audit_id);
      //this.setAuditItemId(audititem_id);
      //this.setDeviationId(deviation_id);

      const payload = { audit_id: audit_id, audititem_id: audititem_id };

      console.log("Delete deviation");

      confirm("Are you sure you want to delete this audit item?") &&
        this.deleteAuditItem(payload);
    },
    callCamera({ ref: { auditId, auditItemId, findingId } }) {
      console.log("Trigger Camera Dialog");
      this.setAuditId(auditId);
      this.setAuditItemId(auditItemId);
      this.setDeviationId(findingId);
      this.$router.push({
        path: "/camera",
        params: {
          audit_id: auditId,
          audititem_id: auditItemId,
          deviation_id: findingId
        }
      });
    },

    openFindingDialog({ ref: { auditId, auditItemId, findingId } }) {
      console.log("Trigger Finding Dialog");
      this.setAuditId(auditId);
      this.setAuditItemId(auditItemId);
      this.setDeviationId(findingId);

      this.currentAuditItem = this.auditItems[auditItemId].question;

      if (typeof findingId === "string") {
        this.setDialogItem({
          ...this.auditItems[auditItemId]["deviations"][findingId]
        });
        this.setDialogAction("update");
      } else {
        const deviation = {};
        this.setDialogItem(deviation);
        this.setDialogAction("create");
      }

      this.dialogDeviation = true;
    },
    createCurrentDeviationAttach({ ref }) {
      console.log(
        "Create deviation quickly with attachment",
        ref.auditId,
        ref.auditItemId
      );

      this.setAuditId(ref.auditId);
      this.setAuditItemId(ref.auditItemId);
      this.$refs.quickattach.click();
    },
    async onAttachmentPicked(e) {
      // set Loading:
      this.setLoading(true);

      console.log("onAttachmentPicked", e);

      const files = e.target.files;

      if (files[0] !== undefined) {
        const imageFile = files[0]; // this is an image file that can be sent to server...
        if (imageFile.name.lastIndexOf(".") <= 0) {
          return;
        }

        const deviation = {
          text: "Das ist ein durch ein Attachment angelegtes Finding",
          importance: "0"
        };

        const payload = {
          ref: {
            auditId: this.getAuditId,
            auditItemId: this.getAuditItemId
          },
          data: deviation,
          writeType: "create"
        };

        try {
          const findingId = await this.storeFinding(payload);
          const uploadSnapshot = await uploadFile(imageFile, {
            ...payload.ref,
            findingId
          });

          console.log(uploadSnapshot);
          const downloadUrl = await uploadSnapshot.ref.getDownloadURL();

          const newpayload = {
            audit_id: this.getAuditId,
            audititem_id: this.getAuditItemId,
            deviation_id: findingId,
            data: { url: downloadUrl }
          };

          await this.attachFileToFinding(newpayload);

          this.setLoading(false);
        } catch (error) {
          console.log("Error Uploading File", error);
          this.setLoading(false);
        }
      }
    },
    pickFile(audit_id, audititem_id, deviation_id, ref) {
      this.setAuditId(audit_id);
      this.setAuditItemId(audititem_id);
      this.setDeviationId(deviation_id);

      const myref = ref || "image";
      this.$refs[myref].click();
    },
    getSeverity(severity, type) {
      if (type == "audititem") {
        return new Importance(
          this.audititem.data.importance.find(setting => setting.id == severity)
        );
      } else if (type == "finding") {
        return new Importance(
          this.getFindingTypes.find(setting => setting.id == severity)
        );
      } else if (type == "measure") {
        return new Importance(
          this.measure.data.types.find(setting => setting.id == severity)
        );
      } else {
        return new Importance();
      }
    },
    orderFindingsByImportance(Findings) {
      if (Findings) {
        const findings_order = this.getFindingsOrder;

        const importanceId2Order = Id => {
          return findings_order.findIndex(v => v == Id);
        };
        let ordered_findings = _.map(Findings, (v, idx) => ({
          o: importanceId2Order(v.importance),
          v: { ...v, id: idx },
          id: idx
        }));
        ordered_findings.sort((lhs, rhs) => lhs.o - rhs.o);
        return _.map(ordered_findings, v => v.v);
      } else {
        return [];
      }
    }
  }
};
</script>
